import React from "react";
import { Survey, SurveyAnswerGraphData } from "../../../../../../../amorg-common";
import { getSurveyAnswerGraphData } from "../../../../../../../api/surveyClientApi";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import * as dateMath from 'date-arithmetic';
import { Label } from "../../../../../../../designSystem/Label";
import { AnswerGraph } from "./AnswerGraph";
import { PageSection } from "../../../../../../../designSystem/PageSection";
import { MessageCard } from "../../../../../../../designSystem/Message";
import { Button } from "../../../../../../../designSystem/button/Button";
import { toDateString } from "../../../../../../../utils/date";
import { Small } from "../../../../../../../designSystem/typography/Body";

type AnswerGraphPanelProps = {
    survey:Survey,
    triggerTimestamp:Date,
}
type AnswerGraphPanelState = {
    loading:boolean,
    graphStartDate:Date,
    graphData:SurveyAnswerGraphData|null
}
export function AnswerGraphPanel(props:AnswerGraphPanelProps):JSX.Element
{
    const [state,setState] = React.useState<AnswerGraphPanelState>({ 
        loading:true,
        graphStartDate:dateMath.add(new Date(), -6, 'day'),
        graphData:null
    });

    React.useEffect(()=>{
        reloadState(state.graphStartDate);
    },[props.triggerTimestamp])

    async function reloadState(startDate:Date) {
        if(props.survey){
            setState({...state, loading:true})
            setState({
                ...state,
                graphStartDate:startDate,
                graphData:await getSurveyAnswerGraphData(props.survey.id, startDate),
                loading:false
            });
        }
    }

    async function dateChanged(startDate:Date)
    {
        setState({
            ...state,
            graphStartDate:startDate,
            graphData:await getSurveyAnswerGraphData(props.survey.id, startDate),
        })
    }

    return (
        <PageSection headerStyleVariant='card' contentStyleVariant='card'
            header={{ 
                title:'Antal gennemført besvarelser over tid',
                customButtonContent:
                    <Flex alignItems="center">
                        <Button variant="text" icon='arrows_chevron_chevronBack' text="" onClick={
                            () => dateChanged(dateMath.add(state.graphStartDate, -1, 'day'))
                        }/>
                        <Small>{toDateString(state.graphStartDate)}</Small>
                        <Button variant="text" icon='arrows_chevron_chevronForward' text="" onClick={
                            () => dateChanged(dateMath.add(state.graphStartDate, 1, 'day')) 
                        }/>
                    </Flex>
            }}>
            
            {props.survey.answerCount === 0 &&
                <MessageCard variant="info" title="Ingen besvarelser" />
            }

            {props.survey.answerCount > 0 &&

                <div>
                    <Flex flexDirection='column' gap={16}>
                        <Flex flexDirection="row" justifyContent="space-between">
                            <Label>Antal gennemførte besvarelser over tid</Label>
                            
                        </Flex>

                        {state.graphData &&
                            <AnswerGraph data={state.graphData} />
                        }
                    </Flex>
                </div>
            }
        </PageSection>
    );
}